import { AfterViewInit, Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { FeatureGroups, Schooladminitem } from 'src/app/models/school/schooladminitem.model';
import { SchoolmanagementService } from 'src/app/services/schoolmanagement.service';
import { moduledetails } from 'src/app/models/module/moduledetails';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { SchoolInformationview } from 'src/app/models/schoolinformationview.model';
import { ModulesComponent } from 'src/app/modules/modules/modules.component';
import { AdminAction } from 'src/app/models/adminaction.model';
import { ToastrService } from 'ngx-toastr';
import { UtilService } from 'src/app/services/util.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ModulePackagesComponent } from 'src/app/modulepackage/module-packages/module-packages.component';
import * as introJs from 'intro.js/intro.js';
import { throwError } from 'rxjs';
import { NotificationInterceptor } from 'src/app/services/interceptor/notification.interceptor';
import { filter } from 'rxjs/operators';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';

declare var $: any;

@Component({
  selector: 'app-schoolhome',
  templateUrl: './schoolhome.component.html',
  styleUrls: ['./schoolhome.component.css']
})
export class SchoolhomeComponent implements OnInit, AfterViewInit {
  //readonly rootURL = environment.ImpataAppAPIRoot;
  //readonly AllSchoolViewType = "ALL_SCHOOL_ITEMS";
  //url:string;
  schoolAdminList: Schooladminitem[];

  //schoolModuleTiles:Moduleviewtile[];
  schoolInfo: SchoolInformationview = new SchoolInformationview();
  isFetchingData: boolean;
  currentUserIsAdmin: boolean;
  addAdminError: string;
  showNewModulePane: boolean;
  newmodule: moduledetails = new moduledetails();
  modulesURL: string;
  descriptionhtml: SafeHtml = '';
  baseUrl: string = '';
  displayFreePlanNotification: boolean = false;
  //moduleurlparam;
  adminActions: AdminAction[] = [];
  @ViewChild('enrolstudents') enrollstudents: ElementRef;
  @ViewChild('sendmail') sendmail: ElementRef;
  @ViewChild('modulesComponent') modulesComponent: ModulesComponent;
  @ViewChildren('hidewhenloading') hidewhenloading: QueryList<ElementRef> = null;
  @ViewChild("descriptiondiv") descriptiondiv: ElementRef;
  @ViewChild('packagesComponent') packagesComponent: ModulePackagesComponent;
  @ViewChild('contact') contact!: ElementRef;
  //id:number;
  //@ViewChild('refreshForm', { static: true }) refreshForm;
  code: any;
  descriptionIsExpanded: boolean = false;
  enrolFileName: string;
  schoollogourl: string;
  introJS = introJs();
  toursteps:any[]=[];
  constructor(private router: Router, private activatedroute: ActivatedRoute, public useraccessservice: UseraccessserviceService,
    private schoolmanagmentservice: SchoolmanagementService, private headerinfo: ComponentheaderService, 
    private modulemanager: ModulemanagementService, private toastr: ToastrService, private util: UtilService, 
    public sanitizer: DomSanitizer, private notificationInterceptor: NotificationInterceptor) {
   this.toursteps= [
    {
       element: '#step30',
       intro: "School Card.",
       position: 'top'
    },    
    {
       element: '#step5',
       intro: 'Courses Created For The School Are Shown Here',
       position: 'right'
    }
 ];
    this.introJS.setOptions({
      steps: this.toursteps,
   showProgress: true
  });

    this.headerinfo.setHeaderDisplay('Loading School...', [], []);

  }


  ///grab schoolid from querystring
  ///on init fetch school information
  ///set SchoolInformationview
  ///set schooladminlist
  ///set currentUserIsAdmin to help hide/show school settings
  ///set schoolModuleTiles

  get windowProtocol(){
    return window.location.protocol;
  }

  async ngOnInit() {
    this.baseUrl = this.util.getImpataBaseUrl();
    await this.setSchoolId();

    this.displayFreePlanNotification = (await this.util.getStaticSchoolInfoBundle())?.schoolConfig?.plan?.free ?? false;

    //debugger;
    this.modulesURL = this.modulemanager.getSchoolModulesURL(this.code);
    this.introJS.oncomplete(function() {
      //this.router.navigate(['/user/editmodule']);   
    window.location.href="/user/editmodule";
    });    
//this.introJS.start();

    // this.url=this.rootURL +`school/getSchoolDetails?schoolID=${this.code}&fetchType=${this.AllSchoolViewType}`
  }

  private async setSchoolId() {
    if (!this.code) {
      this.code = this.activatedroute.snapshot.queryParams.schoolID;
      if (!this.code) {
        try{
          this.notificationInterceptor.SuspendNotification = true;
          const school: any = await this.schoolmanagmentservice.getSchoolFromSubdomain();
          this.code = school.id;
        }
        catch(e){
          if(e.error && e.error.status == 404) {
            window.location.href = '/schoolnotfound';
            throwError(e);
          }
          else{
            throwError(e);
          }
        }
        finally{
          this.notificationInterceptor.SuspendNotification = false;
        }
      }
    }
  }

  async ngAfterViewInit() {
    // this.forceReload();
    await this.getSchoolDetails();

    this.activatedroute.fragment.subscribe(fragment => {
      if (fragment === 'contact')
        setTimeout(() => this.scrollToContactUs(), 500);      
    });

    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => {
        const fragment = this.activatedroute.snapshot.fragment;
        if (fragment === 'contact') 
          setTimeout(() => this.scrollToContactUs(), 500);        
      });

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.fade-in-section, .fade-in-section2')
      .forEach(el => observer.observe(el));
  }

  async getSchoolDetails() {

    //debugger;
    await this.setSchoolId();
    //this.moduleurlparam = { schoolID: this.code };
    this.headerinfo.pageLoadingStarted(this);
    this.schoolmanagmentservice.getSchoolDetails(this.code).subscribe(
      async (data: any) => {

        this.schoolInfo = data.schoolInfo;
        // this.schoollogourl = this.schoolInfo.logoImg + '?' + (new Date()).getTime();
        this.schoollogourl = this.schoolInfo.logoImg;
        this.descriptionhtml = this.sanitizer.bypassSecurityTrustHtml(this.schoolInfo.schoolDescription);
        this.schoolAdminList = data.userList;

        this.currentUserIsAdmin = data.callerIsAdmin;
        if (this.currentUserIsAdmin) {
          this.adminActions = [
            { displaytext: 'School Settings', route: '/user/createschool', classes: ['fa', 'fa-edit'] },
            { displaytext: 'Create New Course', route: '/user/editmodule', params: { schoolID: this.code }, classes: ['fas', 'fa-plus'] },
            { displaytext: 'Create New Package', route: '/user/editpackage', classes: ['fas', 'fa-plus'] },
            { displaytext: 'Enroll Students', callback: this.openenrolmodal.bind(this), classes: ['fas', 'fa-upload'], disabled: !await this.util.hasFeature(FeatureGroups.STUDENT_BULK_UPLOAD), featureGroup: FeatureGroups.STUDENT_BULK_UPLOAD },
            { displaytext: 'Send Email', route: "/user/sendmail", classes: ['fas', 'fa-envelope'], disabled: !await this.util.hasFeature(FeatureGroups.NOTIFICATIONS_EMAILS), featureGroup: FeatureGroups.NOTIFICATIONS_EMAILS },
            { displaytext: 'Manage School Administrators', route: '/user/manageadminusers', classes: ['fas', 'fa-users'] },
            { displaytext: 'View Activity Log', route: '/activity/logs', classes: ['fas', 'fa-list'] },
            { displaytext: 'Account Settings', route: '/account/accountsettings', classes: ['fas', 'fa-cog'] },
            {
              displaytext: 'Customisation',
              route: '/customisation/css',
              classes: ['fas', 'fas fa-file-code'],
              disabled: !await this.util.hasFeature(FeatureGroups.SITE_CUSTOMISATION),
              featureGroup: FeatureGroups.SITE_CUSTOMISATION
            },
            // { displaytext: 'Manage School Plan', route: '/account/schoolplan', params: { schoolid: this.code }, classes: ['fas', 'fa-school'] },
            // { displaytext: 'Manage V-Circle Live Plan', route: '/account/vcircleplan', params: { schoolid: this.code }, classes: ['vcircle-icon'] },
            // { displaytext: 'Manage Account Settings', route: '/account/accountdetails', params: { schoolid: this.code }, classes: ['fas', 'fa-money-check'] },
            {
              displaytext: 'View List of Students',
              route: '/user/schoolstudentlist',
              //params: { schoolid: this.code },
              classes: ['fas', 'fa-street-view'],
            },
          ];
        }

        this.headerinfo.setHeaderDisplay(this.schoolInfo.schoolName, [{ displaytext: this.schoolInfo.schoolName, route: this.activatedroute.snapshot.url.join('/'), params: this.activatedroute.snapshot.queryParams }], this.adminActions,this.toursteps);
        this.newmodule.schoolID = this.schoolInfo.id;
        this.headerinfo.pageLoadingDone(this);



        let descDiv = this.descriptiondiv.nativeElement as HTMLElement;

        console.log(descDiv.scrollHeight, descDiv.clientHeight);



      },
      (err: HttpErrorResponse) => {
        console.log(JSON.stringify(err));
      }
    );
  }

  manageUser(id: number, usernameToManage: string, action: string) {

    this.isFetchingData = true;
    this.schoolmanagmentservice.manageUser(id, usernameToManage, action).subscribe(
      (data: any) => {
        this.schoolAdminList = data;
        this.isFetchingData = false;
        this.addAdminError = null;
      },
      (err: HttpErrorResponse) => {
        if (err.status === 0) {
          this.addAdminError = "Unable to connect to server";
        }
        else if (err.status === 400) {
          this.addAdminError = err.error.message;
        }
        this.isFetchingData = false;
      }
    );

  }

  viewModuleDetails(id) {
    this.router.navigate(['/user/moduledetails'], { queryParams: { moduleID: id } })
  }

  showNewModule() {
    if (this.showNewModulePane) {
      this.showNewModulePane = false;
    } else {
      this.showNewModulePane = true;
    }
  }
  // async closemoduleeditor(toggle: boolean) {
  //   this.newmodule = new moduledetails();
  //   await this.getSchoolDetails();
  //   this.showNewModule();
  // }

  errormessage(error: any) {
    this.addAdminError = error;
  }

  openenrolmodal() {
    $(this.enrollstudents.nativeElement).modal('show');
  }
  closeEnrolModal() {
    $(this.enrollstudents.nativeElement).modal('hide');
  }

  async enrolstudent(file: any) {
    $(this.enrollstudents.nativeElement).modal('hide');
    this.headerinfo.pageLoadingStarted(this);

    let totalfilesize = 0;
    debugger
    let message: any = await this.schoolmanagmentservice.uploadenrolfile(this.code, file).toPromise().catch((err) => { this.toastr.error(err); this.headerinfo.pageLoadingDone(this); return; });
    this.headerinfo.pageLoadingDone(this);
    if (message) {
      this.toastr.success("Done");
      this.toastr.info(message.message);
      console.log(message.timelapsed);
      this.router.navigate(['/user/schoolstudentlist']);
    }
    //window.location.reload();
  }

  openSendMailModal() {
    $(this.sendmail.nativeElement).modal('show');
  }
  closeSendMailModal() {
    $(this.sendmail.nativeElement).modal('hide');
  }
  //forceReload() {
  //  this.refreshForm.nativeElement.submit();
  //}
  scrollToContactUs() {
    this.contact.nativeElement.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }
}